import React, { useContext, useMemo } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import Login from 'pages/Login';
import { listRoutes } from './listRoutes';
import LoginContext from 'context/LoginContext';
import Users from 'pages/Users';
import PageNotFound from 'pages/PageNotFound';
import DynamicPage from 'pages/DynamicPage';
import LayoutMain from 'components/LayoutMain';
// import MenuItensInitial from 'pages/MenuItens';
import MenuItensLocation from 'pages/MenuItensLocation';
import DynamicShowCase from 'pages/DynamicShowCase';
import Settings from 'pages/Settings';
import AdmPainel from 'pages/AdmPainel';
import ItemMenuSelected from 'pages/ItemMenuSelected';
import DynamicPageSelected from 'pages/DynamicPageSelected';
import DndMultipleContainersExample from 'components/DndMultipleContainersExample';
// import DragDrop from 'components/DragDrop';
// import DndExample from 'components/DndExample';
import DnDSortalbe from 'components/DnDSortalbe';
// import Coupons from 'pages/Coupons';
import PrivateRoute from './PrivateRoute';
import AreaLogada from 'components/AreaLogada';
import PriceTag from 'pages/PriceTag';
import ScreensStatic from 'pages/ScreensStatic';
import ScreensTrainings from 'pages/ScreensTrainings';
import Blog from 'pages/Blog';
import BrandBanners from 'pages/BrandBanners';
import Logos from 'pages/Logos';
import Showcase from 'pages/Showcase';
import PlpBanners from 'pages/PlpBanners';
import BannerPopup from 'pages/BannerPopup';
import Contact from 'pages/Contact';

export default function Router() {
	const { isLogged } = useContext(LoginContext);

	const router = useMemo(
		() =>
			createBrowserRouter(
				[
					{
						path: '/', // Rota inicial
						element: (
							<PrivateRoute redirectTo="/">
								<AreaLogada />
							</PrivateRoute>
						)
					},
					{
						path: listRoutes.login,
						element: <Login />
					},
					{
						path: listRoutes.users,
						element: (
							<PrivateRoute redirectTo="/">
								<LayoutMain>
									<Users />
								</LayoutMain>
							</PrivateRoute>
						)
					},
					{
						path: listRoutes.dynamicPages,
						element: (
							<PrivateRoute redirectTo="/">
								<LayoutMain>
									<DynamicPage />
								</LayoutMain>
							</PrivateRoute>
						)
						// element: <LayoutMain>{returnRouterIfAuth(<DragDrop />)}</LayoutMain>
						// element: <LayoutMain>{returnRouterIfAuth(<DndExample />)}</LayoutMain>
						// element: <LayoutMain>{returnRouterIfAuth(<DndMultipleContainersExample />)}</LayoutMain>
						// element: <LayoutMain>{returnRouterIfAuth(<DnDSortalbe />)}</LayoutMain>
					},
					{
						path: `${listRoutes.dynamicPages}1`,
						element: (
							<PrivateRoute redirectTo="/">
								<LayoutMain>
									<DndMultipleContainersExample />
								</LayoutMain>
							</PrivateRoute>
						)
					},
					{
						path: `${listRoutes.dynamicPages}2`,
						element: (
							<PrivateRoute redirectTo="/">
								<LayoutMain>
									<DnDSortalbe />
								</LayoutMain>
							</PrivateRoute>
						)
					},
					// {
					// 	path: listRoutes.menuItens,
					// 	element: (
					// 		<PrivateRoute redirectTo="/">
					// 			<LayoutMain>
					// 				<MenuItensInitial />
					// 			</LayoutMain>
					// 		</PrivateRoute>
					// 	)
					// },
					{
						path: listRoutes.menuItensLocation,
						element: (
							<PrivateRoute redirectTo="/">
								<LayoutMain>
									<MenuItensLocation />
								</LayoutMain>
							</PrivateRoute>
						)
					},
					{
						path: `${listRoutes.menuItensLocation}/:slug`,
						element: (
							<PrivateRoute redirectTo="/">
								<LayoutMain>
									<ItemMenuSelected />
								</LayoutMain>
							</PrivateRoute>
						)
					},
					{
						path: listRoutes.dynamicShowCase,
						element: (
							<PrivateRoute redirectTo="/">
								<LayoutMain>
									<DynamicShowCase />
								</LayoutMain>
							</PrivateRoute>
						)
					},
					{
						path: `${listRoutes.dynamicPages}/:slug`,
						element: (
							<PrivateRoute redirectTo="/">
								<LayoutMain>
									<DynamicPageSelected />
								</LayoutMain>
							</PrivateRoute>
						)
					},
					// {
					// 	path: listRoutes.coupons,
					// 	element: <LayoutMain><Coupons /></LayoutMain>
					// },
					{
						path: listRoutes.settings,
						element: (
							<PrivateRoute redirectTo="/">
								<LayoutMain>
									<Settings />
								</LayoutMain>
							</PrivateRoute>
						)
					},
					{
						path: listRoutes.priceTag,
						element: (
							<PrivateRoute redirectTo="/">
								<LayoutMain>
									<PriceTag />
								</LayoutMain>
							</PrivateRoute>
						)
					},
					{
						path: listRoutes.admPainel,
						element: (
							<PrivateRoute redirectTo="/">
								<LayoutMain>
									<AdmPainel />
								</LayoutMain>
							</PrivateRoute>
						)
					},
					{
						path: listRoutes.screens.static,
						element: (
							<PrivateRoute redirectTo="/">
								<LayoutMain>
									<ScreensStatic />
								</LayoutMain>
							</PrivateRoute>
						)
					},
					{
						path: listRoutes.screens.trainings,
						element: (
							<PrivateRoute redirectTo="/">
								<LayoutMain>
									<ScreensTrainings />
								</LayoutMain>
							</PrivateRoute>
						)
					},
					{
						path: listRoutes.screens.blog,
						element: (
							<PrivateRoute redirectTo="/">
								<LayoutMain>
									<Blog />
								</LayoutMain>
							</PrivateRoute>
						)
					},
					{
						path: listRoutes.brandList.brandBanners,
						element: (
							<PrivateRoute redirectTo="/">
								<LayoutMain>
									<BrandBanners />
								</LayoutMain>
							</PrivateRoute>
						)
					},
					{
						path: listRoutes.brandList.logos,
						element: (
							<PrivateRoute redirectTo="/">
								<LayoutMain>
									<Logos />
								</LayoutMain>
							</PrivateRoute>
						)
					},
					{
						path: listRoutes.showcase,
						element: (
							<PrivateRoute redirectTo="/">
								<LayoutMain>
									<Showcase />
								</LayoutMain>
							</PrivateRoute>
						)
					},
					{
						path: listRoutes.bannerPopup,
						element: (
							<PrivateRoute redirectTo="/">
								<LayoutMain>
									<BannerPopup />
								</LayoutMain>
							</PrivateRoute>
						)
					},
					{
						path: listRoutes.brandList.plpBanners,
						element: (
							<PrivateRoute redirectTo="/">
								<LayoutMain>
									<PlpBanners />
								</LayoutMain>
							</PrivateRoute>
						)
					},
					{
						path: listRoutes.contact,
						element: (
							<PrivateRoute redirectTo="/">
								<LayoutMain>
									<Contact />
								</LayoutMain>
							</PrivateRoute>
						)
					},
					{ path: '*', element: <PageNotFound /> }
				],
				{
					future: {
						v7_relativeSplatPath: true,
						v7_fetcherPersist: true,
						v7_normalizeFormMethod: true,
						v7_partialHydration: true,
						v7_skipActionErrorRevalidation: true
					}
				}
			),
		[isLogged]
	);

	return (
		<RouterProvider
			router={router}
			future={{
				v7_startTransition: true
			}}
		/>
	);
}
